import { render, staticRenderFns } from "./GradingCreate.vue?vue&type=template&id=2aa7f72f"
import script from "../../controllers/grading/grading-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/grading/grading-create.js?vue&type=script&lang=js&external"
import style0 from "./GradingCreate.vue?vue&type=style&index=0&id=2aa7f72f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports